import { connect } from 'react-redux';
import flatten from 'lodash/flatten';
import { trackActions, Dispatch, RootState } from '../../api';
import TracksList, {
  StateProps,
  DispatchProps,
  OwnProps,
} from '../../components/TracksList';

export default connect<StateProps, DispatchProps, OwnProps, RootState>(
  ({
    tracks: {
      entries,
      filteredRandom: { data, pagination },
      isFetchingFilteredRandom,
    },
  }) => ({
    tracks: flatten(Object.values(data || {})).map((id: number) => entries[id]),
    isFetching: isFetchingFilteredRandom,
    currentPage: pagination ? pagination.currentPage : 1,
    lastPageReached: pagination
      ? pagination.currentPage >= pagination.lastPage
      : false,
    playlistType: 'swiper',
  }),
  (dispatch: Dispatch) => ({
    fetchTracks: (filters) =>
      dispatch(trackActions.fetchTracksFilteredRandom(filters)),
  }),
)(TracksList);
